export const contentWidth = 560;
export const contentWidthDesktop = 1000;
